import React from 'react';
import { DocsVerificationStepEnum } from '@models/enums';
import { StartCustomPartner } from '@modules/dashboard/pages/kyc/docs-verification/docs-verification-page/docs-verification-steps/start-custom-partner';
import type { DocsVerificationStepsProps } from '@modules/dashboard/pages/kyc/docs-verification/docs-verification-page/docs-verification-steps/types';
import { useAppSelector } from '@store';
import { useAppTheme } from '@theme';

import { VerificationStep } from '../tabs';

import { DesktopNotAllowedStep } from './dekstop-not-allowed';
import { ExpiredStep } from './expired';
import { FinishStep } from './finish';
import { LandscapeError } from './landscape-error';
import { StartStep } from './start';

export const DocsVerificationSteps: React.FC<DocsVerificationStepsProps> = ({
    onFinish,
    getZkProof,
}) => {
    const theme = useAppTheme();
    const currentStep = useAppSelector((state) => state.docsVerification.currentStep);

    return (
        <React.Fragment>
            {theme.isLandscape && <LandscapeError />}
            {currentStep === DocsVerificationStepEnum.EXPIRED && <ExpiredStep />}
            {currentStep === DocsVerificationStepEnum.DESKTOP_NOT_ALLOWED && (
                <DesktopNotAllowedStep />
            )}
            {currentStep === DocsVerificationStepEnum.START_CUSTOM_PARTNER && (
                <StartCustomPartner />
            )}
            {currentStep === DocsVerificationStepEnum.START && <StartStep />}
            {currentStep === DocsVerificationStepEnum.VERIFICATION && <VerificationStep />}
            {currentStep === DocsVerificationStepEnum.FINISH && (
                <FinishStep onFinish={onFinish} getZkProof={getZkProof} />
            )}
        </React.Fragment>
    );
};
